import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=612bd918&scoped=true&"
import script from "./Vessel.vue?vue&type=script&lang=js&"
export * from "./Vessel.vue?vue&type=script&lang=js&"
import style0 from "./Vessel.vue?vue&type=style&index=0&id=612bd918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612bd918",
  null
  
)

export default component.exports